import { useState } from 'react';
import useMeasure, { UseMeasureRef } from 'react-use/lib/useMeasure';

const useInitialRenderWidth = (): [UseMeasureRef<HTMLDivElement>, number] => {
  const [initialRenderWidth, setInitialRenderWidth] = useState(0);
  const [ref, { width }] = useMeasure<HTMLDivElement>();

  if (width !== 0 && initialRenderWidth === 0) {
    setInitialRenderWidth(width);
  }

  return [ref, initialRenderWidth];
};

export default useInitialRenderWidth;
